import { useEffect, useState } from "react";
import { api, type ModuleFlagRow, type ModuleExecutionMode } from "../api.js";
import { useLocale } from "../ui.js";

const MODES: ModuleExecutionMode[] = ["disabled", "plan_only", "approval_required", "live"];

export function ModuleFlagsPanel({ token }: { token: string }) {
  const { tr } = useLocale();
  const [flags, setFlags] = useState<ModuleFlagRow[] | null>(null);
  const [savingId, setSavingId] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    void api.adminModuleFlags(token).then((res) => {
      if (live) setFlags(res.ok && res.data ? res.data.flags : []);
    });
    return () => {
      live = false;
    };
  }, [token]);

  async function setMode(moduleId: string, mode: ModuleExecutionMode) {
    setSavingId(moduleId);
    const res = await api.adminSetModuleFlag(token, moduleId, mode);
    if (res.ok) {
      setFlags((prev) => prev?.map((f) => (f.moduleId === moduleId ? { ...f, mode, enabled: mode !== "disabled" } : f)) ?? prev);
    }
    setSavingId(null);
  }

  return (
    <section className="panel-card">
      <h2>{tr("modules")}</h2>
      <p className="section-desc">canonical execution mode — persisted in Postgres, enforced by capability activation</p>
      {flags === null ? (
        <p className="muted">{tr("loading")}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Module</th>
              <th>{tr("execution_mode")}</th>
            </tr>
          </thead>
          <tbody>
            {flags.map((f) => (
              <tr key={f.moduleId}>
                <td>{f.moduleId}</td>
                <td>
                  <select
                    value={f.mode}
                    disabled={savingId === f.moduleId}
                    onChange={(e) => void setMode(f.moduleId, e.target.value as ModuleExecutionMode)}
                  >
                    {MODES.map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
